// extracted by mini-css-extract-plugin
module.exports = {"forgotPasswordForm":"forgotPasswordForm--Pt9tgTOH","forgotPasswordText":"forgotPasswordText--DsORUhvt","forgotPasswordDesc":"forgotPasswordDesc--HBHwbauM"};